module.exports = __webpack_public_path__ + "static/media/chart_offensiv.88f5b286.svg";